var _path, _g, _circle, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 116,
    viewBox: "0 0 127 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.748 0.344374C105.435 0.117812 105.064 0.00453049 104.688 0.00453049V0H50.3125C49.3111 0 48.5 0.811094 48.5 1.8125V99.6875C48.5 100.689 49.3111 101.5 50.3125 101.5H59.375V114.188C59.375 114.772 59.6559 115.316 60.1272 115.66C60.4398 115.887 60.8114 116 61.1875 116C61.3778 116 61.5727 115.968 61.7584 115.905L105.258 101.405C105.997 101.16 106.5 100.467 106.5 99.6875V1.81703C106.5 1.2325 106.219 0.688749 105.748 0.344374ZM60.6166 14.5997C59.8734 14.8444 59.375 15.5377 59.375 16.317V97.8795H52.125V3.62953H93.518L60.6166 14.5997Z",
    fill: "#28353C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5861_47442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5003 40.1667L24.9153 42.7517L33.312 51.1667H3.66699V54.8334H33.312L24.897 63.2484L27.5003 65.8334L40.3337 53L27.5003 40.1667Z",
    fill: "#28353C"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 53,
    r: 22,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5861_47442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.982 34.6667C94.862 34.6667 86.667 42.88 86.667 53C86.667 63.12 94.862 71.3334 104.982 71.3334C115.12 71.3334 123.334 63.12 123.334 53C123.334 42.88 115.12 34.6667 104.982 34.6667ZM105 67.6667C96.897 67.6667 90.3337 61.1034 90.3337 53C90.3337 44.8967 96.897 38.3334 105 38.3334C113.104 38.3334 119.667 44.8967 119.667 53C119.667 61.1034 113.104 67.6667 105 67.6667ZM105.917 43.8334H103.167V54.8334L112.792 60.6084L114.167 58.3534L105.917 53.4584V43.8334Z",
    fill: "#28353C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5861_47442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0 31)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5861_47442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(83 31)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/check-in.2c1e378810760014e1dd46690ad9c65e.svg";
export { ForwardRef as ReactComponent };